import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppComponent } from './app/app';
import { routes } from './app/app.routes';
import { jwtInterceptor } from './app/core/interceptore/jwt.interceptor';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, {
    providers:[
        provideRouter(routes),
        provideHttpClient(withInterceptors([jwtInterceptor]))
    ]
})
.catch(err => console.error(err));
